import apiClient from '@/api/ApiClient';

export async function downloadProof(donationId: number, type: 'proof' | 'second', token: string) {
  try {
    const res = await apiClient.get(
      `donations/pending/${donationId}/download-proof?type=${type}`,
      { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' }
    );

    const contentDisposition = res.headers['content-disposition'] ?? '';
    const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
    const fileName = match?.[1] ?? 'file';

    const blobUrl = URL.createObjectURL(res.data as Blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
  } catch {
    console.error('Download failed');
  }
}
